import { render, staticRenderFns } from "./ConfigChannelView.vue?vue&type=template&id=47ae143e&"
import script from "./ConfigChannelView.vue?vue&type=script&lang=ts&"
export * from "./ConfigChannelView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports